if (typeof window.reactComponents === 'undefined') {
  window.reactComponents = {}
}
